/**
 * return current year in string
 */
const getCurrentYear = () => {
	return new Date().toISOString().slice(0, 4);
};

export default getCurrentYear;
